// Coexistence helpers (ADR 0017): areas not yet ported link out to the same
// react-admin path on the portal.

/**
 * `APP_PORTAL_URL` + the same path (and query). Null when no portal URL is
 * configured, so callers can hide the link instead of linking nowhere.
 */
export function portalHref(
  path: string,
  portalUrl: string | undefined = import.meta.env.APP_PORTAL_URL
): string | null {
  const base = portalUrl?.trim()
  if (!base) return null
  return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
}

/**
 * Whether this app serves `area` (a resource's first path segment, e.g.
 * `modules`, `upgradeprocess`). With `APP_PORTED_AREAS` unset or empty,
 * every area is served here.
 */
export function isPortedArea(
  area: string,
  portedAreas: string | undefined = import.meta.env.APP_PORTED_AREAS
): boolean {
  const list = (portedAreas ?? '')
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean)
  return list.length === 0 || list.includes(area.toLowerCase())
}
